import { Link, useLocation } from 'react-router-dom';
import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const AdminLayout = ({ children }) => {
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const location = useLocation();

	const navigation = [
		{ name: 'Dashboard', href: '/admin', icon: 'Dashboard' },
		{ name: 'Image Manager', href: '/admin/images', icon: 'Image' },
		{ name: 'Homepage Content', href: '/admin/homepage', icon: 'Home' },
		{ name: 'Practice Areas', href: '/admin/practice-areas', icon: 'Briefcase' },
		{ name: 'Attorneys', href: '/admin/attorneys', icon: 'Users' },
		{ name: 'Publications', href: '/admin/publications', icon: 'FileText' },
		{ name: 'Careers', href: '/admin/careers', icon: 'Briefcase' },
		{ name: 'Company Info', href: '/admin/company-info', icon: 'Building' },
	];

	return (
		<div className='min-h-screen bg-gray-50'>
			{/* Mobile sidebar */}
			<div className={`fixed inset-0 z-50 lg:hidden ${sidebarOpen ? 'block' : 'hidden'}`}>
				<div
					className='fixed inset-0 bg-gray-600 bg-opacity-75'
					onClick={() => setSidebarOpen(false)}
				/>
				<div className='relative flex-1 flex flex-col max-w-xs w-full bg-white'>
					<div className='absolute top-0 right-0 -mr-12 pt-2'>
						<button
							type='button'
							className='ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'
							onClick={() => setSidebarOpen(false)}
						>
							<Icon name='X' className='h-6 w-6 text-white' />
						</button>
					</div>
					<div className='flex-1 h-0 pt-5 pb-4 overflow-y-auto'>
						<div className='flex-shrink-0 flex items-center px-4'>
							<h1 className='text-xl font-bold text-[#800020]'>FEPA Admin</h1>
						</div>
						<nav className='mt-5 px-2 space-y-1'>
							{navigation.map((item) => (
								<Link
									key={item.name}
									to={item.href}
									className={`${
										location.pathname === item.href
											? 'bg-[#800020] text-white'
											: 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
									} group flex items-center px-2 py-2 text-base font-medium rounded-md`}
								>
									<Icon name={item.icon} className='mr-4 h-6 w-6' />
									{item.name}
								</Link>
							))}
						</nav>
					</div>
				</div>
			</div>

			{/* Desktop sidebar */}
			<div className='hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0'>
				<div className='flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white'>
					<div className='flex-1 flex flex-col pt-5 pb-4 overflow-y-auto'>
						<div className='flex items-center flex-shrink-0 px-4'>
							<h1 className='text-xl font-bold text-[#800020]'>FEPA Admin</h1>
						</div>
						<nav className='mt-5 flex-1 px-2 space-y-1'>
							{navigation.map((item) => (
								<Link
									key={item.name}
									to={item.href}
									className={`${
										location.pathname === item.href
											? 'bg-[#800020] text-white'
											: 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
									} group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
								>
									<Icon name={item.icon} className='mr-3 h-6 w-6' />
									{item.name}
								</Link>
							))}
						</nav>
					</div>
				</div>
			</div>

			{/* Main content */}
			<div className='lg:pl-64 flex flex-col flex-1'>
				<div className='sticky top-0 z-10 lg:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-gray-50'>
					<button
						type='button'
						className='-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#800020]'
						onClick={() => setSidebarOpen(true)}
					>
						<Icon name='Menu' className='h-6 w-6' />
					</button>
				</div>
				<main className='flex-1'>
					<div className='py-6'>
						<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>{children}</div>
					</div>
				</main>
			</div>
		</div>
	);
};

export default AdminLayout;
